import { Schema } from "effect";
import { JsonValue } from "./canonical-json.ts";
import { CommitId, TaskId, WorkspaceId } from "./development-identifiers.ts";
import { StationPath } from "./station-path.ts";

export const CandidateConflictKind = /* @__PURE__ */ (() => Schema.Literals([
  "overlapping-content", "modify-delete", "incompatible-rename",
  "workspace-topology", "binding", "migration", "configuration"
]))();
export type CandidateConflictKind = typeof CandidateConflictKind.Type;

export const CandidateConflictLocation = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ axis: Schema.Literals(["file", "rename"]), workspaceId: WorkspaceId, path: StationPath }),
  Schema.Struct({ axis: Schema.Literals(["workspace", "folder", "option"]), workspaceId: WorkspaceId, field: Schema.optionalKey(Schema.String) }),
  Schema.Struct({ axis: Schema.Literals(["workspace-order", "active-workspace"]), field: Schema.optionalKey(Schema.String) }),
  Schema.Struct({ axis: Schema.Literals(["binding", "migration", "configuration"]), field: Schema.String })
]))();
export type CandidateConflictLocation = typeof CandidateConflictLocation.Type;

export const CandidateConflictValue = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ present: Schema.Literal(false) }),
  Schema.Struct({ present: Schema.Literal(true), value: JsonValue })
]))();
export type CandidateConflictValue = typeof CandidateConflictValue.Type;

export const CandidateConflictSource = /* @__PURE__ */ (() => Schema.Union([
  Schema.Struct({ sourceKind: Schema.Literal("target"), sourceId: Schema.String, commitId: CommitId, value: CandidateConflictValue }),
  Schema.Struct({ sourceKind: Schema.Literal("task"), sourceId: TaskId, commitId: CommitId, value: CandidateConflictValue })
]))();
export type CandidateConflictSource = typeof CandidateConflictSource.Type;

export const CandidateConflict = /* @__PURE__ */ (() => Schema.Struct({
  version: Schema.Literal(1), conflictId: Schema.String, kind: CandidateConflictKind,
  location: CandidateConflictLocation, candidateGeneration: Schema.Number,
  base: Schema.Struct({ commitId: CommitId, value: CandidateConflictValue }),
  inputs: Schema.Array(CandidateConflictSource), inputsDigest: Schema.String
}))();
export type CandidateConflict = typeof CandidateConflict.Type;

export const CandidateCompositionIdentity = /* @__PURE__ */ (() => Schema.Struct({
  version: Schema.Literal(1), algorithm: Schema.Literal("station-three-way-v1"),
  candidateGeneration: Schema.Number, baseCommitId: CommitId,
  target: Schema.Struct({ ref: Schema.String, commitId: CommitId, refRevision: Schema.Number }),
  taskHeads: Schema.Array(Schema.Struct({ taskId: TaskId, commitId: CommitId }))
}))();
export type CandidateCompositionIdentity = typeof CandidateCompositionIdentity.Type;

export const ConflictedCandidateComposition = /* @__PURE__ */ (() => Schema.Struct({
  status: Schema.Literal("conflicted"), identity: CandidateCompositionIdentity,
  conflicts: Schema.Array(CandidateConflict), compositionDigest: Schema.String
}))();
export type ConflictedCandidateComposition = typeof ConflictedCandidateComposition.Type;
